import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

/**
 * A 401 from the API means the session is gone (expired/invalid). Rather than
 * stranding the user on a half-logged-in page rendering "Authentication
 * required", bounce them to the login screen. Guarded so it can't loop on the
 * login page itself. Route guards already cover the load-time case; this
 * catches a session that dies *while* a page is open.
 */
function redirectToLoginOnUnauthorized(err: unknown): void {
  if ((err as { statusCode?: number })?.statusCode !== 401) return;
  if (typeof window === 'undefined' || window.location.pathname === '/login') return;
  window.location.assign('/login');
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: redirectToLoginOnUnauthorized }),
  mutationCache: new MutationCache({ onError: redirectToLoginOnUnauthorized }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, err) => {
        const status = (err as { statusCode?: number })?.statusCode;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
